import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/nova-roots-way', label: 'Our Way' },
    { path: '/learning-model', label: 'Learning Model' },
    { path: '/living-curriculum', label: 'Living Curriculum' },
    { path: '/living-cultures', label: 'Living Cultures' },
    { path: '/environment', label: 'Environment' },
    { path: '/walezi', label: 'Walezi' },
    { path: '/faith-learning', label: 'Faith & Worldview' },
    { path: '/nairobi-pilot', label: 'Nairobi Pilot' },
    { path: '/admissions', label: 'Admissions' },
    { path: '/fees', label: 'Fees' },
    { path: '/founder', label: 'Founder' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/nova-roots-logo-small.png" alt="Nova Roots" className="logo-image" />
          <span className="logo-text">Nova Roots</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="header-cta">
          <Link to="/contact">
            <Button className="cta-button">Register Interest</Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
            <Button className="mobile-cta-button">Register Interest</Button>
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;